import { render, staticRenderFns } from "./CopyrightAmendmentEscalations.vue?vue&type=template&id=13b9ba73&scoped=true&"
import script from "./CopyrightAmendmentEscalations.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentEscalations.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentEscalations.vue?vue&type=style&index=0&id=13b9ba73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9ba73",
  null
  
)

export default component.exports